// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function useCustomPaymentMethodConfigs(paymentMethod, paymentMethodType) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var paymentMethodsConfig = match.paymentMethodsConfig;
  var allowedPmTypeForCardPayment = [
    "debit",
    "credit"
  ];
  return React.useMemo((function () {
                return paymentMethodsConfig.filter(function (paymentMethodConfig) {
                                  return paymentMethodConfig.paymentMethod === paymentMethod;
                                }).flatMap(function (paymentMethodConfig) {
                                return paymentMethodConfig.paymentMethodTypes;
                              }).filter(function (paymentMethodTypeConfig) {
                              if (paymentMethod === "card") {
                                return allowedPmTypeForCardPayment.includes(paymentMethodTypeConfig.paymentMethodType);
                              } else {
                                return paymentMethodTypeConfig.paymentMethodType === paymentMethodType;
                              }
                            })[0];
              }), [
              paymentMethod,
              paymentMethodType,
              paymentMethodsConfig
            ]);
}

export {
  useCustomPaymentMethodConfigs ,
}
/* react Not a pure module */
